import { apiResponseErrorHandler, apiResponseErrorHandlerClient } from 'helpers/common.helper';
import axios from 'axios';

export default {
	forgotPasswordClient(data) {
		return this.handelAlert((res, rej, loadobj) => {
			axios
				.post(`${base}/api/client/password/request`, data)
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					res(rej.response.data);
				});
		}, false);
	},
	forgotPasswordClientVerifyEmail(data) {
		return this.handelAlert((res, rej, loadobj) => {
			axios
				.post(`${base}/api/client/password/verify-email`, data)
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					res(rej.response.data);
				});
		}, false);
	},
	getAllClientProducts() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/api/client/products/list?status=active`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientInterest() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/interests`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getCreateReturnsClient(data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/returns`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	getReturnsImeiClient(data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/returns/client/get-stocks-items/imeis`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	getClientSpec() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/specifications`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	aprroveAgreement(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/agreement_approve/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},

	getClientInfo(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientInformation(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/client_information/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientInformationAddress(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/client_information/address/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientInformationBank(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/client_information/bank/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientInformationSurvey(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/client_information/survey/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	addClientPortal(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/client/add-portal`, data, {
					headers: {
						Authorization: `Bearer ${
							JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
						}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	addClient(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/register`, data)
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response);
				});
		}, false);
	},
	loginClient(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/login`, data)
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					res(rej.response);
				});
		}, false);
	},

	getCountryList(type) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/api/country-list`)
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	checkEmailSendingStatus(type) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/api/check-email-sending-status`)
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},

	getSelectOptionsListClient(type) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/client/selections?type=${type}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	clientlogout() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadobj) => {
			axios
				.get(`${base}/client/logout`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((e) => {
					apiResponseErrorHandlerClient(e);
					rej(e);
				});
		}, false);
	},
	updateClientInfo(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/${id}/company_info`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	updateClientAddress(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/${id}/company_address`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	storeClientDocuments(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/${id}/company_documents/store`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	updateClientDocuments(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/${id}/company_documents`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	updateClientBankDetails(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/${id}/company_bank_details`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	addToCart(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/cart/${id}`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	getCartItems(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/get-cart-items/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getCartDetails(id) {
		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/cart-value/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	updateCartItem(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/cart/${id}/update-quantity`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	deleteCartItem(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.delete(`${base}/client/cart/${id}/delete`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					},
					data: data
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	completeClientRegistration(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/${id}/complete_registration`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},
	updateClientInterest(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/${id}/company_interests`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandlerClient(rej);
					res(rej.response.data);
				});
		}, false);
	},

	getClientIvoices(id, page = 1, search = null) {
		let url = `${base}/client/invoices/${id}?page=${page}`;
		if (search) {
			url += `&search=${search}`;
		}

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(url, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},

	getClientOrders(id, page = 1, search = null) {
		let url = `${base}/client/orders/${id}?page=${page}`;
		if (search) {
			url += `&search=${search}`;
		}

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(url, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientReturns(id, page = 1, search = null) {
		let url = `${base}/client/returns/${id}?page=${page}`;
		if (search) {
			url += `&search=${search}`;
		}

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(url, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientEstimates(id, page = 1, search = null) {
		let url = `${base}/client/estimates/${id}?page=${page}`;
		if (search) {
			url += `&search=${search}`;
		}

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(url, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	downloadImei(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/imei/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					},
					responseType: 'blob'
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	downloadAWB(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/awb-download/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					},
					responseType: 'blob'
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	GetAvailableAWB(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/awb/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},

	getClientInvoiceNumberList(id, estimationId = null) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/invoice_customer/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientInvoiceNumberCustomer(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/invoice_customer_details/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientReturnsStandardRepairTypes() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/selections?type=standard_repair_types`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getTurnOvers() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/turnover`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	company_activities() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/company_activity`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},

	getPlatformList() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/platform_list`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getClientInterestList() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/interests`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getAppClient() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/app_client`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},

	getEmployeeList() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/employee_list`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	getEstimationByQoutationId(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/show_qoutation/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},

	getSalesPerson() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/sales-information`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},

	getPurchasingDetails(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/get-purchasing-details/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},
	updateClientGeneralInformation(data) {
		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

		
		return this.handelAlert((res, rej, loadObj) => {

			axios
				.post(`${base}/client/client-information/update`, data, {
					headers: {
						'Content-Type': 'multipart/form-data',
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	updateClientGeneralInformationAddress(data) {
		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;
		
		
		return this.handelAlert((res, rej, loadObj) => {

			axios
				.post(`${base}/client/client-information/address/update`, data, {
					//check
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	UpdateClientInformationBank(data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/client-information/bank/update`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	getReturnsDetailsClient(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/client/returns-details/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	addReturnedProductsClient(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/returns/${id}/add-returned-products`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	deleteReturnedProductsClient(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.delete(`${base}/client/returns/${id}/delete-returned-products`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	getAvailableReturnsImeiClient(estimationId, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/returns/${estimationId}/get-avaiable-items`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	updateReturnedProductsClient(id, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.put(`${base}/client/returns/${id}/update-returned-products`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	getAvailableReturnsImeiClient(estimationId, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/returns/${estimationId}/get-avaiable-items`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	getReturnsStandardRepairTypesClient() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/client/selections?type=standard_repair_types`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	getUnassignedInvoiceNumberListClient(estimationId = null) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;
		
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/client/selections?type=invoice_customer${estimationId ? `&estimation_id=${estimationId}` : ''}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	getProductFiltersClient() {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/api/client/products/filter`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	filterProductClient(filters, search = null, status) {
		let url = `${base}/api/client/products/list?status=${status}&`;


		Object.keys(filters).forEach((key) => {
			if (Array.isArray(filters[key])) {
				url += `${key}=${filters[key].map((item) => item.value).join(',')}&`;
			} else if (filters[key].value !== undefined) {
				url += `${key}=${filters[key].value}&`;
			}
		});


		if (search) {
			url += `search=${search}`;
		}


		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(url, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	paginationapiClient(url) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${url}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	getProductDetailsClient(id) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return new Promise((resolve, reject) => {
			axios
				.get(`${base}/client/products-details/${id}`, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log(error);
					apiResponseErrorHandlerClient(error);
					reject(error.response);
				});
		});
	},


	getClientTimeline(data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/client/timeline`, data, {
					headers: {
						// Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token}`
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},



	// New API Calls

	// async getClientQuotations(filters, search = null, sortByFilter = null) {
	// 	let url = `${base}/client/quotations?`;

	// 	Object.keys(filters).forEach((key) => {
	// 		if (key != 'startDate' && key != 'endDate') {
	// 			url += `${key}=${filters[key].value}&`;
	// 		} else {
	// 			url += `${key}=${filters[key]}&`;
	// 		}
	// 	});

	// 	if (search) {
	// 		url += `search=${search}`;
	// 	}

	// 	if (sortByFilter) {
	// 		url += `&sortBy=${sortByFilter?.field}&sortOrder=${sortByFilter?.direction}`;
	// 	}

	// 	const clientLocal = localStorage.getItem('client');
	// 	const clientSession = sessionStorage.getItem('client');
	// 	const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;



	// 	return result;
	// 	// }, false);
	// },
	

	async getClientQuotations(query, statusType, filters, search = null, sortByFilter = null) {
		let url = `${base}/client/quotations?page=${query?.page || 1}&${statusType ? 'statusType=' + statusType + '&' : ''}`;

		Object.keys(filters).forEach((key) => {
			if (key != 'startDate' && key != 'endDate') {
				url += `${key}=${filters[key].value}&`;
			} else {
				url += `${key}=${filters[key]}&`;
			}
		});

		if (search) {
			url += `search=${search}`;
		}

		if (sortByFilter) {
			url += `&sortBy=${sortByFilter?.field}&sortOrder=${sortByFilter?.direction}`;
		}

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		const result = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${clientToken}`
			}
		});

		return result;
		// }, false);
	},

	
	getClientQuotationFilter() {
		return this.handelAlert((res, rej, loadObj) => {
			const clientLocal = localStorage.getItem('client');
			const clientSession = sessionStorage.getItem('client');
			const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

			const url = `${base}/client/quotations/filter/get`;
			axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	async getClientQuotationDetails(id) {
		let url = `${base}/client/quotation/${id}`;

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		const result = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${clientToken}`
			}
		});

		return result;
		// }, false);
    },




	getClientTimeline(data) {
		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/timeline`, data, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},


	getClientSettings() {
		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/client/settings`, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	clientAcceptQuotaiton(data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/quotations/accept`, data, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},


	clientDownloadQuotation(ref, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

		return this.handelAlert((res, rej, loadObj) => {
			axios
				// .post(`${base}/client/estimations/${ref}/get-estimate-file`, data, {
				.post(`${base}/client/quotation/${ref}/get-file`, data, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					},
					responseType: 'blob'
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	// async getClientInvoices(filters, search = null, sortByFilter = null) {
	// 	let url = `${base}/client/invoices?`;

	// 	Object.keys(filters).forEach((key) => {
	// 		if (key != 'startDate' && key != 'endDate') {
	// 			url += `${key}=${filters[key].value}&`;
	// 		} else {
	// 			url += `${key}=${filters[key]}&`;
	// 		}
	// 	});

	// 	if (search) {
	// 		url += `search=${search}`;
	// 	}

	// 	if (sortByFilter) {
	// 		url += `&sortBy=${sortByFilter?.field}&sortOrder=${sortByFilter?.direction}`;
	// 	}

	// 	const clientLocal = localStorage.getItem('client');
	// 	const clientSession = sessionStorage.getItem('client');
	// 	const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;



	// 	return result;
	// 	// }, false);
	// },
	

	getClientInvoiceFilter() {
		return this.handelAlert((res, rej, loadObj) => {
			const url = `${base}/client/invoices/filter/get`;
			const clientLocal = localStorage.getItem('client');
			const clientSession = sessionStorage.getItem('client');
			const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


							
			axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	async getClientInvoices(query, statusType, filters, search = null, sortByFilter = null) {
		let url = `${base}/client/invoices?page=${query?.page || 1}&${statusType ? 'statusType=' + statusType + '&' : ''}`;

		Object.keys(filters).forEach((key) => {
			if (key != 'startDate' && key != 'endDate') {
				url += `${key}=${filters[key].value}&`;
			} else {
				url += `${key}=${filters[key]}&`;
			}
		});

		if (search) {
			url += `search=${search}`;
		}

		if (sortByFilter) {
			url += `&sortBy=${sortByFilter?.field}&sortOrder=${sortByFilter?.direction}`;
		}

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		const result = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${clientToken}`
			}
		});

		return result;
		// }, false);
	},

	async getClientInvoiceDetails(id) {
		let url = `${base}/client/invoice/${id}`;

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		const result = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${clientToken}`
			}
		});

		return result;
		// }, false);
    },

	clientDownloadInvoice(ref, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

		return this.handelAlert((res, rej, loadObj) => {
			axios
				// .post(`${base}/client/estimations/${ref}/get-estimate-file`, data, {
				.post(`${base}/client/invoice/${ref}/get-file`, data, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					},
					responseType: 'blob'
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	getClientSalesOrdersFilter() {
		return this.handelAlert((res, rej, loadObj) => {
			const url = `${base}/client/sales-orders/filter/get`;
			axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('client'))?.token || JSON.parse(sessionStorage.getItem('client')).token || token
							}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	async getClientSalesOrders(query, filters, search = null, sortByFilter = null) {
		let url = `${base}/client/sales-orders?page=${query?.page || 1}&`;

		Object.keys(filters).forEach((key) => {
			if (key != 'startDate' && key != 'endDate') {
				url += `${key}=${filters[key].value}&`;
			} else {
				url += `${key}=${filters[key]}&`;
			}
		});

		if (search) {
			url += `search=${search}`;
		}

		if (sortByFilter) {
			url += `&sortBy=${sortByFilter?.field}&sortOrder=${sortByFilter?.direction}`;
		}

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		const result = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${clientToken}`
			}
		});

		return result;
		// }, false);
	},

	// async getClientSalesOrders(filters, search = null, sortByFilter = null) {
	// 	let url = `${base}/client/sales-orders?`;

	// 	Object.keys(filters).forEach((key) => {
	// 		if (key != 'startDate' && key != 'endDate') {
	// 			url += `${key}=${filters[key].value}&`;
	// 		} else {
	// 			url += `${key}=${filters[key]}&`;
	// 		}
	// 	});

	// 	if (search) {
	// 		url += `search=${search}`;
	// 	}

	// 	if (sortByFilter) {
	// 		url += `&sortBy=${sortByFilter?.field}&sortOrder=${sortByFilter?.direction}`;
	// 	}

	// 	const clientLocal = localStorage.getItem('client');
	// 	const clientSession = sessionStorage.getItem('client');
	// 	const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


	// 	return result;
	// 	// }, false);
    // },

	async getClientSalesOrderDetails(id) {
		let url = `${base}/client/sales-order/${id}`;

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		const result = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${clientToken}`
			}
		});

		return result;
		// }, false);
    },


	clientDownloadSalesOrder(ref, data) {

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/client/sales-order/${ref}/get-file`, data, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					},
					responseType: 'blob'
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	verifyClientAuthTokenSession(id) {
		let url = `${base}/client/verification/${id}/verify-token`;

		const clientLocal = localStorage.getItem('client');
		const clientSession = sessionStorage.getItem('client');
		const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;


		const result = axios.get(url, {
			headers: {
				Authorization: `Bearer ${clientToken}`
			}
		});

		return result;
    },
	getClientSerialFilter() {
		return this.handelAlert((res, rej, loadObj) => {
			const clientLocal = localStorage.getItem('client');
			const clientSession = sessionStorage.getItem('client');
			const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

			const url = `${base}/client/serials/filter/get`;
			axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	getClientSerial(params = {}) {
		return this.handelAlert((res, rej, loadObj) => {
			const clientLocal = localStorage.getItem('client');
			const clientSession = sessionStorage.getItem('client');
			const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

			const url = `${base}/client/serials`;

			console.log('Getting client serials with params:', params);

			axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					},
					params: params
				})
				.then((response) => {
					res(response.data);
				})
				.catch((error) => {
					apiResponseErrorHandler(error);
					res(error.response ? error.response.data : error);
				});
		}, false);
	},

	getClientShipments(params = {}) {
		return this.handelAlert((res, rej, loadObj) => {
			const clientLocal = localStorage.getItem('client');
			const clientSession = sessionStorage.getItem('client');
			const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

			const url = `${base}/client/shipments`;

			axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					},
					params: params
				})
				.then((response) => {
					res(response.data);
				})
				.catch((error) => {
					apiResponseErrorHandler(error);
					res(error.response ? error.response.data : error);
				});
		}, false);
	},

	getClientSettings() {
		return this.handelAlert((res, rej, loadObj) => {
			const clientLocal = localStorage.getItem('client');
			const clientSession = sessionStorage.getItem('client');
			const clientToken = (clientLocal && JSON.parse(clientLocal)?.token) || (clientSession && JSON.parse(clientSession)?.token) || token;

			axios
				.get(`${base}/client/settings`, {
					headers: {
						Authorization: `Bearer ${clientToken}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
};
